<div class="container p-3">
    <div [formGroup]="newNotificationFormGroup">
        <div class="row">
            <div class="col-auto">
                <div class="mb-3">
                    <label>Recipients</label>
                    <div>
                        <label class="btn btn-sm btn-outline text-secondary" (click)="selectAll()">
                            <i class="far fa-plus-square"></i> all
                        </label>
                        <label class="btn btn-sm btn-outline text-secondary" (click)="selectNone()">
                            <i class="far fa-minus-square"></i> none
                        </label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetCS" formControlName="newNotificationTargetCS">
                        <label class="form-check-label" for="newNotificationTargetCS">Czech (cs)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetDE" formControlName="newNotificationTargetDE">
                        <label class="form-check-label" for="newNotificationTargetDE">German (de)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetEL" formControlName="newNotificationTargetEL">
                        <label class="form-check-label" for="newNotificationTargetEL">Greek (el)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetEN" formControlName="newNotificationTargetEN">
                        <label class="form-check-label" for="newNotificationTargetEN">English (en)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetES" formControlName="newNotificationTargetES">
                        <label class="form-check-label" for="newNotificationTargetES">Spanish (es)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetFR" formControlName="newNotificationTargetFR">
                        <label class="form-check-label" for="newNotificationTargetFR">French (fr)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetHE" formControlName="newNotificationTargetHE">
                        <label class="form-check-label" for="newNotificationTargetHE">Hebrew (he)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetIT" formControlName="newNotificationTargetIT">
                        <label class="form-check-label" for="newNotificationTargetIT">Italian (it)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetJA" formControlName="newNotificationTargetJA">
                        <label class="form-check-label" for="newNotificationTargetJA">Japanese (ja)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetKO" formControlName="newNotificationTargetKO">
                        <label class="form-check-label" for="newNotificationTargetKO">Korean (ko)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetNL" formControlName="newNotificationTargetNL">
                        <label class="form-check-label" for="newNotificationTargetNL">Dutch (nl)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetPL" formControlName="newNotificationTargetPL">
                        <label class="form-check-label" for="newNotificationTargetPL">Polish (pl)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetRU" formControlName="newNotificationTargetRU">
                        <label class="form-check-label" for="newNotificationTargetRU">Russian (ru)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetTH" formControlName="newNotificationTargetTH">
                        <label class="form-check-label" for="newNotificationTargetTH">Thai (th)</label>
                    </div>
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="newNotificationTargetZH" formControlName="newNotificationTargetZH">
                        <label class="form-check-label" for="newNotificationTargetZH">Chinese (zh)</label>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="newNotificationTitle">Title</label>
                    <input type="text" class="form-control" id="newNotificationTitle" maxlength="200" formControlName="newNotificationTitle">
                </div>
                <div class="mb-3">
                    <label for="newNotificationBody">Body</label>
                    <textarea type="text" class="form-control" id="newNotificationBody" rows="10" maxlength="2000" formControlName="newNotificationBody"></textarea>
                </div>
                <div class="mb-3 row gx-1">
                    <div class="col-auto">
                        <button class="btn btn-primary" [disabled]="newNotificationFormGroup.invalid || noTarget" (click)="send()">
                            <i class="fas fa-paper-plane"></i> Send
                        </button>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-outline-secondary" (click)="erase()">
                            <i class="fas fa-eraser"></i> Erase
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>